import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable, of } from 'rxjs';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { FieldQueryFilterComponent } from '../field-query-filter/field-query-filter.component';
import { SiModalModule } from '../../si-modal';
import { HubspotEnrichmentFetchFilterTypeEnum } from '../../../enums';
import { HubspotEnrichmentJobFilterParametersDto, HubspotMappingFieldsByItemType } from '../../../dto';
import { VIEW_FILTER_DIALOG_SERVICE_INJECTION_TOKEN } from './view-filters-dialog-service-injection-token.config';
import { ViewFiltersDialogService } from './view-filters-dialog-service.interface';

@Component({
  templateUrl: './view-filters-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, SiModalModule, FieldQueryFilterComponent, FormsModule, MatButtonModule],
})
export class ViewFiltersDialogComponent {
  readonly isLoading$: Observable<boolean>;
  readonly fields$: Observable<HubspotMappingFieldsByItemType[]>;
  readonly listName$: Observable<string>;
  readonly hubspotEnrichmentFetchFilterTypeEnum: typeof HubspotEnrichmentFetchFilterTypeEnum = HubspotEnrichmentFetchFilterTypeEnum;

  constructor(
    @Inject(MAT_DIALOG_DATA) readonly data: HubspotEnrichmentJobFilterParametersDto,
    @Inject(VIEW_FILTER_DIALOG_SERVICE_INJECTION_TOKEN) readonly viewFiltersDialogService: ViewFiltersDialogService,
  ) {
    this.isLoading$ = this.viewFiltersDialogService.isLoading$;
    this.fields$ = this.viewFiltersDialogService.getFieldsObservable(this.data);
    this.listName$ = this.viewFiltersDialogService.getListNameObservable(this.data);
  }
}
